import * as Sentry from '@sentry/react'
import { useMutation } from '@tanstack/react-query'

import { sendEvent } from 'src/shared/api/events/send-event'

interface SentryBugReport {
  name?: string
  email?: string
  message: string
}

export const useSendSentryBug = () => {
  return useMutation({
    mutationFn: async (data: SentryBugReport) => {
      const result = await Sentry.captureFeedback(
        {
          name: data.name,
          email: data.email,
          message: data.message,
        },
        {
          includeReplay: true, // Include session replay if configured
        },
      )
      sendEvent({
        eventType: 'sentry_bug_report_submitted',
        info: {
          hasName: !!data.name,
          hasEmail: !!data.email,
        },
      })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'sentry_bug_report_error',
        info: { error: errorName },
      })
    },
  })
}
